import { Erp1cAnalyticDimensionKeyEnum } from '@zaoblako/shared/modules/catalog/enums/erp-1c-analytic-dimension-key.enum';
import { Connection1cFindDto, type Connection1cFindInterface } from '@zaoblako/shared/modules/integration/dtos/connection-1c/connection-1c-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';

import * as yup from 'yup';

/** Accounting account dimensions setting response body - DTO signature */
export interface AccountDimensionSettingFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Setting creation date and type */
  created: Date;
  /** Setting last update date and type */
  updated: Date;
  /** Setting soft deletion date and type */
  deleted?: Date;

  // Data columns
  /** Setting display name */
  name: string;
  /** Analytics dimension unit */
  dimension: Erp1cAnalyticDimensionKeyEnum;
  /** Related 1C ERP databases */
  connections?: Connection1cFindInterface[];
}

/** Accounting account dimensions setting response body - DTO schema */
export const AccountDimensionSettingFindDto = SerdeDtoClass.create<AccountDimensionSettingFindInterface>(
  CatalogDtosKeysEnum.ACCOUNT_DIMENSION_SETTING_FIND_DTO,
  {
    id: {
      sortable: true,
      label: 'Номер',
      serializer: yup.number(),
    },
    created: {
      sortable: true,
      label: 'Создан',
      serializer: yup.date(),
    },
    updated: {
      label: 'Изменен',
      serializer: yup.date(),
    },
    deleted: {
      optional: true,
      label: 'Удален',
      serializer: yup.date(),
    },
    name: {
      sortable: true,
      label: 'Наименование субконто',
      serializer: yup.string(),
    },
    dimension: {
      label: 'Тип субконто',
      serializer: yup
        .string()
        .oneOf(Object.values(Erp1cAnalyticDimensionKeyEnum)),
    },
    connections: {
      optional: true,
      label: 'Базы 1С',
      nested: Connection1cFindDto,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
